import React, { Component } from "react";
import * as  grouped from "./controlsmore";


const where_pending = (d) => {
  let pend = "";
  if (['Not Started', 'NO', 'In Progress', 'Incomplete'].includes(d.inspection_status) && !d.skip_rows) {
    if (d.recompliance_id) {
      if (d.createdby == d.updatedby) {
        pend = "Branch Manager";
      } else {
        pend = "Auditor";
      }
    } else {
      pend = "Branch Manager";
    }
  } else if (!d.inspection_status && !d.skip_rows) {
    pend = "Auditor";
  }

  return pend;
}

const recovery_percentage = (d) => {
  let rec_pct = 100 * (parseFloat(d.New_Total ? d.New_Total : 0) - parseFloat(d.advance_recovery ? d.advance_recovery : 0)) / parseFloat(d.Old_Total ? d.Old_Total : 0);
  console.log({ d, New_Total: d.New_Total, advance_recovery: d.advance_recovery, Old_Total: d.Old_Total, rec_pct });
  return rec_pct;
}







function footerButtonsLogicLoan(buttonName) {

  let Cash_Credit_Loan = "63e8c7f4-6f50-4158-bbba-a82cd59720c6";
  let Loan_against_Fixed_Deposit = "10ab5cbc-e186-434c-bd00-06cff95abb02";
  let Gold_Loan_Installment = "1a04411a-ec4d-43e0-96a5-da7d9637297c";
  let Gold_Loan = "7f5e7e90-c24c-496f-b99d-1db0703e42fa";
  let Housing_Loan = "49c67fb8-33ee-43e5-b103-648b1cdf4578";
  let Project_Loan = "590d994b-2279-4080-b4d5-3279c3a837e5";
  let Consortium_Loan = "ad64994d-cda8-46c3-9ebc-11299a448ae9";
  let Installment_Loan = "51128286-617b-11e3-aaf2-000423cb8521";
  let Vehicle_Loan = "046d8f75-73a8-11e3-aebc-001a64c6d97a";

  let Cash_Credit_Deposit_Loan = "08eb8bc7-73a8-11e3-aebc-001a64c6d97a";

  let Bills_Loan = "cf48d928-5b2a-11e3-ad02-4c72b931b19d";
  let Bank_CASA = "6538b358-8935-40b7-951a-3cff5de49f4d";
  let Bank_TD = "1c414ba5-136a-4596-be22-efa8b72d447d";
  let Bank_OD = "5370d795-cbea-4b5f-add9-db7314d245eb";
  let Govt_Investment = "1bc18dff-f187-4125-b14f-adbe3374fa01";
  let Other_Receivable = "1f7bb82f-f60c-44fb-a586-e55184ae8989";
  let Other_Payable = "42934925-7707-4a7e-aa7b-2088fa678f74";
  let Income = "bb7e9b77-555c-4f4c-bb6c-a9150c20cb5d";
  let Expenses = "8ca00aa3-0bd8-4e8c-9b04-78901c284457";
  let Interest_Received = "36be17c1-af7f-40d1-a726-7d398fde5875";
  let Interest_Paid = "3e750d78-8088-4a9b-88d9-e35b4a0bc5ed";
  let General = "11844493-5723-11e3-8e91-4c72b931b19d";
  let Locker_Advance = "5286852c-bbf9-11e3-9b69-645a0455d710";
  let Security_Loan = "35ab5cbc-e186-434c-bd00-06cff95abb02";
  let BankGuarantee = "5555852c-bbf9-11e3-9b69-645a0455d710";



  let definitions = {

    loanaction: [Cash_Credit_Loan, Installment_Loan, Project_Loan, Housing_Loan, Consortium_Loan, Cash_Credit_Deposit_Loan, Loan_against_Fixed_Deposit, Govt_Investment], // Except Loan_against_Fixed_Deposit
    gold: [Gold_Loan, Gold_Loan_Installment],
    installment: [Gold_Loan_Installment, Installment_Loan, Project_Loan, Housing_Loan, Consortium_Loan, Vehicle_Loan, Loan_against_Fixed_Deposit, Govt_Investment],
    leinmarking: [Cash_Credit_Loan, Installment_Loan, Project_Loan, Housing_Loan, Consortium_Loan, Cash_Credit_Deposit_Loan, Loan_against_Fixed_Deposit, Govt_Investment],
    securitydetails: [Cash_Credit_Loan, Security_Loan, Installment_Loan, Project_Loan, Housing_Loan, Consortium_Loan, Govt_Investment],
    cashcreditrenewal: [Cash_Credit_Loan, Cash_Credit_Deposit_Loan],
    vehicle: [Vehicle_Loan],


    // loandetail: [Current, Fixed_Deposit, Recurring_Deposit, Reinvestment_Deposit, Savings_Regular],
    // loanaction: [Current, Fixed_Deposit, Recurring_Deposit, Reinvestment_Deposit, Savings_Regular],
    // loandocuments: [Current, Fixed_Deposit, Recurring_Deposit, Reinvestment_Deposit, Savings_Regular],
    // otherinformation: [Current, Fixed_Deposit, Recurring_Deposit, Reinvestment_Deposit, Savings_Regular],
    // npainformation: [Current, Fixed_Deposit, Recurring_Deposit, Reinvestment_Deposit, Savings_Regular],
    // intstopinformation: [Current, Fixed_Deposit, Recurring_Deposit, Reinvestment_Deposit, Savings_Regular],
    // vehicle: [Vehicle_Loan],
    // gold: [Gold_Loan],
    // guarantor: [Current, Fixed_Deposit, Recurring_Deposit, Reinvestment_Deposit, Savings_Regular],

  }
  // check the product & whether in edit mode.
  // console.log({mode})
  // console.log(definitions[buttonName]);
  return definitions[buttonName];

}

function footerButtonsLogicDeposit(buttonName) {

  let Savings_Regular = "f38ef10a-4ea0-11e3-9221-4c72b931b19d";
  let Savings_Swift = "58ec36b4-39ee-4b7b-a9c9-3d4f3042a76d";
  let Savings_No_Frill = "7d2d4dcc-9133-40c4-b8d0-18ed8e1584c7";

  let Current = "e55b3b1d-0e63-4aee-89a5-618cdf8227dd";
  let Current_Swift = "50e4d581-d192-47ff-8ad9-db20c995da37";

  let Fixed_Deposit = "87e5be37-3150-4770-9cfb-91426aaafac2";
  let Recurring_Deposit = "e7575178-fd21-4d7a-ba32-987e84fb62fa";
  let Pension_Deposit = "90ac9793-3eb9-4302-bbc5-60a1dbf84b85";
  let Reinvestment_Deposit = "501efb9e-62cd-4226-ba7e-87d564cdfec9";
  let Call_Deposit = "75d72756-4e43-4e8d-8e6a-da63803990e3";
  let Swift_Deposit = "20f71c58-ac91-4b7c-a2d3-1ea3fcc4d19f";

  let Pigmy_Deposit = "d41e2746-5b2a-11e3-ad02-4c72b931b19d";

  let definitions = {
    termdeposit: [Fixed_Deposit, Reinvestment_Deposit, Call_Deposit, Recurring_Deposit, Pension_Deposit],
    // recurringdeposit: [Recurring_Deposit, Pension_Deposit],
    pigmydeposit: [Pigmy_Deposit],

    // show only while editing.
    leinmarking: [Fixed_Deposit, Recurring_Deposit, Pension_Deposit, Reinvestment_Deposit, Call_Deposit],

    // for all while editing in deposits.
    minimumbalance: [Savings_Regular, Savings_Swift, Savings_No_Frill, Current, Current_Swift],
    overdraft: [Savings_Regular, Savings_Swift, Savings_No_Frill, Current, Current_Swift],
  }
  // check the product & whether in edit mode.
  // console.log({mode})
  // console.log(definitions[buttonName]);
  return definitions[buttonName];
}

function userLoginbranch(branchname) {
  controls.log(this.props.parentState)
}

const currencyToNumber = (currency) => {
  // Check whether amount in rupees or crores etc.
  const regex = /,/g
  let ret = parseFloat(currency.replace(regex, ''));
  return ret;
}
const checkCondition = (data) => {
  // Check whether amount in rupees or crores etc.
  let data1 = String(data)
  let value = data1.startsWith("H")
  return value;
}

const commonfields = (inputs = {}, defaults = {}) => {
  return {
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    tab: inputs.tab ? inputs.tab : "",
    parents: inputs.parents ? inputs.parents : [],
    onRender: inputs.onRender ? inputs.onRender : [],
    defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
      children: "col-sm-12"
    },
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : false,
    name: inputs.name ? inputs.name : defaults.name ? defaults.name : "",
    placeHolder: inputs.placeHolder ? inputs.placeHolder : defaults.placeHolder ? defaults.placeHolder : "",
    tabindex: inputs.tabindex ? inputs.tabindex : defaults.tabindex ? defaults.tabindex : "",
    label: inputs.label ? inputs.label : defaults.label ? defaults.label : "",
    description: inputs.description ? inputs.description : defaults.description ? defaults.description : "",
    onLeave: inputs.onLeave ? inputs.onLeave : false,
    displaytype: inputs.displaytype ? inputs.displaytype : "",
    style: inputs.style ? inputs.style : defaults.style ? defaults.style : {},
    default: inputs.default ? inputs.default : "",
    options: inputs.options ? inputs.options : [],
    maxlength: inputs.maxlength ? inputs.maxlength : 9999,
    sendToServer: inputs.sendToServer ? inputs.sendToServer : "",
    requiredKey: inputs.requiredKey ? inputs.requiredKey : "",
    data: inputs.data ? inputs.data : [],
    focus: inputs.focus ? inputs.focus : false,
    liveValidation: inputs.liveValidation ? inputs.liveValidation : false,
    insertonly: inputs.insertonly ? inputs.insertonly : false,
    formula: inputs.formula ? inputs.formula : false,
    hidden: inputs.hidden ? inputs.hidden : false,
    next_field: inputs.next_field ? inputs.next_field : false,
    clearData: inputs.clearData ? inputs.clearData : false,
    displayData: inputs.displayData ? inputs.displayData : false
  }
};

const commonOC = (inputs = {}, defaults = {}) => {
  let cd = inputs.name.indexOf('-') != -1 ? inputs.name.split("-") : inputs.name.split(".");



  let should_auto_generate = true;

  let basename = inputs.name.replace("_code", "");

  let myuid = basename + "_uid";
  let mydisplay = basename + "_display";
  let disdata = inputs.displayData ? inputs.displayData : {};

  let codename = cd[cd.length - 1];
  let nn = codename.replace("_code", "_display");
  let nuid = codename.replace("_code", "_uid");
  let convertVariables = {};


  for (var key in disdata) {
    if (disdata[key].indexOf('_display') != -1) {
      should_auto_generate = false;
    }
    convertVariables[key] = disdata[key];
  }
  if (should_auto_generate) {
    convertVariables[nn] = mydisplay;
    convertVariables[nuid] = myuid;
  }

  if (cd.length > 1 && inputs.name.indexOf('[') == -1) {
    convertVariables[codename] = inputs.name;
  }

  let sts = { dataType: inputs.c + "_control" };
  if (inputs.sendToServer) {
    sts = { ...sts, ...inputs.sendToServer };
  }

  // let control_master={CropType:'ms441',AccountNumber:{BeforeLeave,},PAN:}
  return {
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isRequired: inputs.isRequired ? inputs.isRequired : false,
    tab: inputs.tab ? inputs.tab : "",
    parents: inputs.parents ? inputs.parents : [],
    hidden: inputs.hidden ? inputs.hidden : false,
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    model: inputs.c ? inputs.c : inputs.controlType ? inputs.controlType : "",
    fastpath: inputs.fastpath ? inputs.fastpath : "",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: inputs.controlSearch ? inputs.controlSearch : "",
      display: 'filter',
      populate: 'code'
    },
    // value:lastYearEnd(),
    validations: inputs.validations ? inputs.validations : false,
    defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
    label: inputs.label ? inputs.label : "",
    name: inputs.name ? inputs.name : "",
    description: inputs.description ? inputs.description : "",
    sendToServer: sts,
    requiredKey: inputs.name,
    displayData: convertVariables,
    beforeLeave: inputs.beforeLeave ? inputs.beforeLeave : false,
    clearData: inputs.clearData ? inputs.clearData : false,
    length: inputs.length ? inputs.length : 1000,
    autoopen: inputs.autoopen ? inputs.autoopen : false,
    next_field: inputs.next_field ? inputs.next_field : false
  }
}


const controls = {
  // Add following controls to ORO_Control.
  // PAN, aadhaar, mobile, date, text, number, float, textArea, address, pincode, 
  oc: (inputs = {}) => {
    return [commonOC(inputs)];
    // return [
    //   {
    //     tag: inputs.tag,
    //     icon: inputs.icon ? inputs.icon : "",
    //     inputType: "modalinput",
    //     isRequired: inputs.isRequired ? inputs.isRequired : false,
    //     tab: inputs.tab ? inputs.tab : "",
    //     parents: inputs.parents ? inputs.parents : [],
    //     widths: {
    //       parent: inputs.width ? inputs.width : "col-sm-2",
    //       children: "col-sm-12"
    //     },
    //     formmodal: {
    //       tag: inputs.tag,
    //       icon: inputs.icon ? inputs.icon : "",
    //       inputType: "fastpathContainer",
    //       pagename: "croptypesearch",
    //       display: 'filter',
    //       populate: 'code'
    //     },
    //     // value:lastYearEnd(),
    //     defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
    //     isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    //     placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
    //     // label: "Sample Modal",
    //     name: inputs.name ? inputs.name : "",
    //     description: inputs.description ? inputs.description : "",
    //     sendToServer: { dataType: inputs.c + "_control" },
    //     requiredKey: inputs.name,
    //     displayData: inputs.displayData ? inputs.displayData : { [nn]: nn, uid: nuid },
    //   }
    // ];
  },
  piechart: (inputs = {}) => [
    {
      ...commonfields(inputs),
      inputType: "piechart",
      dims: inputs.dims ? inputs.dims : {}
    },
  ],

  numtoword: (inputs = {}) => [
    {
      ...commonfields(inputs),
      inputType: "numtoword",
      validations: [{ rule: "^[0-9]{0,}[.]{0,1}[0-9]{0,2}", message: " must be number" }],
      convertedTo: inputs.name ? inputs.name + "_str_amount" : "NumToWordTEXT",
    },
    {
      inputType: "showdata",
      ...commonfields({ ...inputs, width: inputs.textwidth ? inputs.textwidth : "col-sm-2", name: inputs.name + "_str_amount" }),
      more: inputs.more ? inputs.more : "",
      data: inputs.name + "_str_amount",
    }
  ],
  hr: (inputs = {}) => [
    {
      ...commonfields(inputs),
      inputType: "hr",
    },
  ],
  Email: (inputs = {}) => [
    {
      ...commonfields(inputs, { name: "email", placeHolder: "Email" }),
      inputType: "text",
      validations: [{ rule: "^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})", message: "Invalid email." }],
      description: "Enter Email"
    },
  ],
  mobileNumber: (inputs = {}) => [
    {
      ...commonfields(inputs, { name: "mobile_no", placeHolder: "Mobile No" }),
      inputType: "numberonly",
      validations: [
        {
          rule: "^[0-9]{10}",
          message: "must be 10 digits long"
        }
      ],
      description: "Enter Mobile no"
    }
  ],
  floatOnly: (inputs = {}) => [
    {
      ...commonfields(inputs),
      inputType: "text",
      validations: [
        {
          rule: "^([0-9]){1,}([.]){0,1}([0-9]){0,6}",
          message: "Can only be decimal"
        }
      ],
      description: "Enter a number"
    }
  ],
  panNumber: (inputs = {}) => [
    {
      ...commonfields(inputs, { style: { fontSize: 20, paddingTop: 0, paddingBottom: 0 }, name: "pan", placeHolder: "PAN Number" }),
      inputType: "text",
      validations: [{ rule: "^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}", message: "PAN number is INVALID" }],
      description: "Enter pan_number"
    }
  ],
  stringOnly: (inputs = {}) => [
    {
      ...commonfields(inputs, { style: { fontSize: 20, paddingTop: 0, paddingBottom: 0 }, name: "pan", placeHolder: "Character Only" }),
      inputType: "text",
      validations: [{ rule: "^([a-zA-Z]){1,500}", message: "Characters only" }],
      description: "Enter string"
    }
  ],
  creditCard: (inputs = {}) => [
    {
      ...commonfields(inputs, { style: { fontSize: 20, paddingTop: 0, paddingBottom: 0 }, name: "pan", placeHolder: "PAN Number" }),
      inputType: "text",
      validations: [{ rule: "^([a-zA-Z]){16}", message: "Card number is INVALID" }],
      description: "Enter credit card"
    }
  ],
  ifsc: (inputs = {}) => [
    {
      ...commonfields(inputs, { style: { fontSize: 20, paddingTop: 0, paddingBottom: 0 }, name: "ifsc", placeHolder: "IFSC" }),
      inputType: "text",
      validations: [{ rule: "^([a-zA-Z]){4}([0-9A-Za-z]){7}", message: "IFSC is INVALID" }],
      description: "IFSC"
    }
  ],
  tanNumber: (inputs = {}) => [
    {
      ...commonfields(inputs, { style: { color: "green", fontSize: 20, paddingTop: 0, paddingBottom: 0 }, name: "tan", placeHolder: "TAN Number" }),
      inputType: "text",
      validations: [{ rule: "^([a-zA-Z]){4}([0-9]){5}([a-zA-Z]){1}", message: "TAN number is INVALID" }],
      description: "Enter TAN"
    }
  ],
  gstinNumber: (inputs = {}) => [
    {
      ...commonfields(inputs, { style: { color: "green", fontSize: 20, paddingTop: 0, paddingBottom: 0 }, name: "gstin", placeHolder: "GST Number" }),
      inputType: "text",
      validations: [{ rule: "^([0-9]){2}([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}([0-9]){1}([a-zA-Z]){2}", message: "GSTIN is INVALID" }],
      description: "Enter GSTIN"
    }
  ],
  aadharNumber: (inputs = {}) => [
    {
      ...commonfields(inputs, { style: { color: "green", fontSize: 20, paddingTop: 0, paddingBottom: 0 }, name: "aadhar", placeHolder: "AADHAR Number" }),
      inputType: "numberonly",
      validations: [
        {
          rule: "^([0-9]){12}",
          message: "AADHAR number is INVALID. Must be 12 digits."
        }
      ],
      description: "Enter Aadhaar number"
    }
  ],
  ckycNumber: (inputs = {}) => [
    {
      ...commonfields(inputs, { name: "ckyc", placeHolder: "CKYC Number" }),
      inputType: "numberonly",
      validations: [
        {
          rule: "^([0-9]){14}",
          message: "CKYC number is INVALID. Must be 14 digits."
        }
      ],
      description: "Enter CKYC number"
    }
  ],
  pinCode: (inputs = {}) => [
    {
      ...commonfields(inputs, { name: "pin_code", placeHolder: "Pincode" }),
      inputType: "text",
      validations: [{ rule: "^[0-9]{6}", message: "Pincode is INVALID" }],
      description: "Enter pin_code"
    }
  ],
  text: (inputs = {}) => [
    {
      inputType: "text",
      ...commonfields(inputs),
    },
  ],
  textArea: (inputs = {}) => [
    {
      inputType: "textarea",
      ...commonfields(inputs),
    },
  ],
  simpleeditor: (inputs = {}) => [

    {
      inputType: "simpleeditor",
      tab: inputs.tab ? inputs.tab : "create",
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      label: "",
      name: inputs.name,
      description: "none",
      style: inputs.style ? inputs.style : {}
    },
  ],
  numberOnly: (inputs = {}) => [
    {
      inputType: "numberonly",
      ...commonfields(inputs),
    },
  ],
  perPage: (inputs = {}) => [
    {
      inputType: "numberonly",
      ...commonfields(inputs, { name: "perpage" }),
    },
  ],
  datePicker: (inputs = {}) => [
    {
      inputType: "date",
      ...commonfields(inputs),
    },
  ],
  gchart: (inputs = {}) => [
    {
      inputType: "gchart",
      charttype: inputs.charttype ? inputs.charttype : "bar",
      ...commonfields(inputs, { placeHolder: "dd/mm/yyyy" }),
      default: inputs.default ? inputs.default : "",
      displayFormat: inputs.displayFormat ? inputs.displayFormat : "dd/MM/yyyy",
      convertedTo: inputs.convertedTo ? inputs.convertedTo : "",
      dateType: inputs.dateType ? inputs.dateType : "ontype",
      minDate: inputs.minDate ? inputs.minDate : "",
      ddType: inputs.ddType ? inputs.ddType : false,
      dformat: inputs.dformat ? inputs.dformat : false
    },
  ],
  nivoChart: (inputs = {}) => [
    {
      inputType: "nivoChart",
      charttype: inputs.charttype ? inputs.charttype : "bar",
      ...commonfields(inputs, { placeHolder: "dd/mm/yyyy" }),
      ddType: inputs.ddType ? inputs.ddType : "",
      width: inputs.width ? inputs.width : 100
    },
  ],
  barChart: (inputs = {}) => [
    {
      inputType: "barChart",
      ...commonfields(inputs, { placeHolder: "dd/mm/yyyy" }),
      ddType: inputs.ddType ? inputs.ddType : "",
      width: inputs.width ? inputs.width : 100,
      icon: inputs.icon ? inputs.icon : "",
      clickable: inputs.clickable ? inputs.clickable : false,
      emptymsg: inputs.emptymsg ? inputs.emptymsg : false,
      reportName: inputs.reportName ? inputs.reportName : false,
      format: inputs.format ? inputs.format : false,
      label_field: inputs.label_field ? inputs.label_field : false,
      axes_labels: inputs.axes_labels ? inputs.axes_labels : false,
      legend: inputs.legend ? inputs.legend : false,
      column_defs: inputs.column_defs ? inputs.column_defs : false,
      index_by: inputs.index_by ? inputs.index_by : false,
      aria_label: inputs.aria_label ? inputs.aria_label : false,
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-12",
        children: "col-sm-12"
      },
      query_group: inputs.query_group ? inputs.query_group : false

    },
  ],
  progressBar: (inputs = {}) => [
    {
      inputType: "progressbar",
      charttype: inputs.charttype ? inputs.charttype : "bar",
      ...commonfields(inputs, { placeHolder: "dd/mm/yyyy" }),
      ddType: inputs.ddType ? inputs.ddType : "",
      width: inputs.width ? inputs.width : 100,
      format: inputs.format ? inputs.format : "",
      dformat: inputs.dformat ? inputs.dformat : "",
      values: inputs.values ? inputs.values : []
    },
  ],
  progressBarCustom: (inputs = {}) => [
    {
      inputType: "progressbarcustom",
      ...commonfields(inputs, { placeHolder: "dd/mm/yyyy" }),
      reportName: inputs.reportName ? inputs.reportName : "",
      label_field: inputs.label_field ? inputs.label_field : 100,
      pct_labels: inputs.pct_labels ? inputs.pct_labels : "",
      is_pct: inputs.is_pct ? inputs.is_pct : false,
      subtotal_definitions: inputs.subtotal_definitions ? inputs.subtotal_definitions : {},
      query_group: inputs.query_group ? inputs.query_group : false
    },
  ],
  gmapCustom: (inputs = {}) => [
    {
      inputType: "gmapcustom",
      ...commonfields(inputs),
      reportName: inputs.reportName ? inputs.reportName : ""
    },
  ],
  gmapWidget: (inputs = {}) => [
    {
      inputType: "gmapwidget",
      ...commonfields(inputs),
      reportName: inputs.reportName ? inputs.reportName : ""
    },
  ],
  magicDate: (inputs = {}) => [
    {
      inputType: "magicdate",
      ...commonfields(inputs, { placeHolder: "dd/mm/yyyy" }),
      default: inputs.default ? inputs.default : "",
      displayFormat: inputs.displayFormat ? inputs.displayFormat : "dd/MM/yyyy",
      convertedTo: inputs.convertedTo ? inputs.convertedTo : "",
      dateType: inputs.dateType ? inputs.dateType : "ontype",
      minDate: inputs.minDate ? inputs.minDate : "",
      maxDate: inputs.maxDate ? inputs.maxDate : "",
    },
  ],
  flatFootersGenerator: (inputs = {}) => [
    {
      inputType: "flatFootersGenerator",
      ...commonfields(inputs),
      components: inputs.components,
      pivot_fastpath: inputs.pivot_fastpath,
      pivotat: inputs.pivotat,
      foot: inputs.foot,
      otherData: inputs.otherData ? inputs.otherData : false
    },
  ],
  dashboardsGenerator: (inputs = {}) => [
    {
      inputType: "dashboardsGenerator",
      ...commonfields(inputs),
      components: inputs.components,
    },
  ],
  showData: (inputs = {}) => [
    {
      inputType: "showdata",
      ...commonfields(inputs),
      more: inputs.more ? inputs.more : "",
      data: inputs.data ? inputs.data : "",
      dheight: inputs.dheight ? inputs.dheight : false,
      fixed: inputs.fixed ? inputs.fixed : false,
      dynamicDescription: inputs.dynamicDescription ? inputs.dynamicDescription : false
    },
  ],
  select: (inputs = {}) => [
    {
      inputType: "select",
      ...commonfields(inputs),
      options: inputs.options ? inputs.options : [],
    },
  ],
  dataList: (inputs = {}) => [
    {
      inputType: "datalist",
      ...commonfields(inputs),

      list: inputs.list ? inputs.list : "",
      options: inputs.options ? inputs.options : [],
    },
  ],
  checkBox: (inputs = {}) => [
    {
      inputType: "checkbox",
      ...commonfields(inputs),
    },
  ],
  radio: (inputs = {}) => [
    {
      inputType: "radio",
      ...commonfields(inputs),
    },
  ],

  closeAc: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "checkbox",
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      parents: inputs.parents ? inputs.parents : [],
      star: inputs.star ? inputs.star : "",
      default: inputs.default ? inputs.default : "",
      sendToServer: { sendData: ['product_type_guid', 'account_number_guid'], dataType: "closeAc" },
      onLeave: [{ status: true, action: "calculateInterest" }],
      requiredKey: "intcalc",
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
        children: "col-sm-12"
      },
      label: inputs.label ? inputs.label : "",
      name: inputs.name ? inputs.name : "",
      description: inputs.description ? inputs.description : "",
    },
  ],
  autoComplete: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "autocomplete",
      style: inputs.style ? inputs.style : {},
      disableSearch: inputs.disableSearch ? inputs.disableSearch : false,
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      is_ajax: inputs.is_ajax ? inputs.is_ajax : null,
      parents: inputs.parents ? inputs.parents : [],
      controlType: inputs.controlType ? inputs.controlType : inputs.c ? inputs.c : null,
      label: inputs.label ? inputs.label : "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
        children: "col-sm-12"
      },
      options: inputs.options ? inputs.options : [],
      ajaxLoad: true,
      isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : false,
      ajaxOptions: inputs.ajaxOptions ? inputs.ajaxOptions : {},
      placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
      name: inputs.name ? inputs.name : "",
      description: inputs.description ? inputs.description : "",
      next_field: inputs.next_field ? inputs.next_field : false,
      sendToServer: inputs.sendToServer ? inputs.sendToServer : false,
      displayData: inputs.displayData ? inputs.displayData : {},
    }
  ],
  autoCompleteMultiple: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "autocompletemulti",
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      parents: inputs.parents ? inputs.parents : [],
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
        children: "col-sm-12"
      },
      options: inputs.options ? inputs.options : [],
      ajaxLoad: true,
      ajaxOptions: inputs.ajaxOptions ? inputs.ajaxOptions : {},
      placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
      name: inputs.name ? inputs.name : "",
      // label:inputs.label? inputs.label:"",
      description: inputs.description ? inputs.description : ""
    }
  ],

  displayText: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "displaytext",
    tab: inputs.tab ? inputs.tab : "",
    star: inputs.star ? inputs.star : "",
    style: inputs.style ? inputs.style : {},
    prepend: inputs.prepend ? inputs.prepend : [],
    parents: inputs.parents ? inputs.parents : [],
    description: inputs.description ? inputs.description : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    label: inputs.label ? inputs.label : ""
  }],
  displayImage: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "displaytext",
    tab: inputs.tab ? inputs.tab : "",
    star: inputs.star ? inputs.star : "",
    style: inputs.style ? inputs.style : {},
    prepend: inputs.prepend ? inputs.prepend : [],
    parents: inputs.parents ? inputs.parents : [],
    description: inputs.description ? inputs.description : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    label: inputs.label ? inputs.label : ""
  }],
  denominationrow: (inputs = {}) => [{
    inputType: "displaytext",
    widths: {
      parent: "col-sm-1",
      children: "col-sm-12"
    },
    label: String(inputs.sr)
  },
  {
    inputType: "displaytext",
    widths: {
      parent: "col-sm-4",
      children: "col-sm-12"
    },
    label: String(inputs.denomination)
  },
  {
    inputType: "numberonly",
    ...commonfields({ ...inputs, width: "col-sm-3" }),
  },
  {
    inputType: "gendata",
    displaytype: "currency",
    formula: [{ action: "multiply", mult: inputs.value, datavars: [inputs.name] }, { action: "setvar", name: inputs.name + "_display" }],
    widths: {
      parent: "col-sm-4",
      children: "col-sm-12"
    },
  },
  {
    ...commonfields({ ...inputs, width: "col-sm-12" }),
    inputType: "hr",
  },
  ],
  magicDateLabel: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    labelComponent: "magicdate",
    inputType: "displaytext",
    tab: inputs.tab ? inputs.tab : "",
    star: inputs.star ? inputs.star : "",
    style: inputs.style ? inputs.style : {},
    parents: inputs.parents ? inputs.parents : [],
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    description: inputs.description ? inputs.description : null,
    label: inputs.label ? inputs.label : "",
    // labelShortcuts: inputs.labelShortcuts ? inputs.labelShortcuts : [{ label: "Session", value: "sd" }, { label: "Today", value: "n" }, { label: "Yesterday", value: "y" }, { label: "Month Start", value: "ms" }, { label: "Month End", value: "me" }, { label: "1 April", value: "fs" }, { label: "31 March", value: "fe" }, { label: "1 Jan", value: "ys" }, { label: "31 Dec", value: "ye" }, { label: "Quarter Start", value: "qs" }, { label: "Quarter End", value: "qe" }, { label: "Last Friday", value: "lf" }],
    // Last month, 
    target: inputs.target ? inputs.target : ""
  }],
  branch: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      displaytype: inputs.displaytype ? inputs.displaytype : "",
      inputType: "modalinput",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      tab: inputs.tab ? inputs.tab : "",
      parents: inputs.parents ? inputs.parents : [],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-2",
        children: "col-sm-12"
      },
      formmodal: {
        tag: inputs.tag,
        icon: inputs.icon ? inputs.icon : "",
        inputType: "fastpathContainer",
        pagename: "brsearch",
        display: 'filter',
        populate: 'code'
      },
      // value:lastYearEnd(),
      defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
      isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
      placeHolder: "Parent Branch",
      // label: "Sample Modal",
      name: "branch_code",
      description: "Parent Branch",
      sendToServer: { dataType: "branch" },
      requiredKey: "branch_display",// without this key, 
      // reverseSearch:{},
      displayData: { branch_display: "branch_display", branch_code_guid: "branch_code_guid", branch_code: "branch_code" },
    }
  ],
  crop: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "modalinput",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      tab: inputs.tab ? inputs.tab : "",
      parents: inputs.parents ? inputs.parents : [],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-2",
        children: "col-sm-12"
      },
      formmodal: {
        tag: inputs.tag,
        icon: inputs.icon ? inputs.icon : "",
        inputType: "fastpathContainer",
        pagename: "cropsearch",
        display: 'filter',
        populate: 'code'
      },
      // value:lastYearEnd(),
      defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
      isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
      placeHolder: "Crop",
      // label: "Sample Modal",
      name: "crop_code",
      description: "Crop",
      sendToServer: { dataType: "crop_control" },
      requiredKey: "crop_code_display",// without this key, 
      // reverseSearch:{},
      displayData: { crop_display: "crop_code_display", crop_code: "crop_code" },
    }
  ],

  cropType: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "modalinput",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      tab: inputs.tab ? inputs.tab : "",
      parents: inputs.parents ? inputs.parents : [],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-2",
        children: "col-sm-12"
      },
      formmodal: {
        tag: inputs.tag,
        icon: inputs.icon ? inputs.icon : "",
        inputType: "fastpathContainer",
        pagename: "croptypesearch",
        display: 'filter',
        populate: 'code'
      },
      // value:lastYearEnd(),
      defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
      isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
      placeHolder: "Crop Type",
      // label: "Sample Modal",
      name: "crop_type_code",
      description: "Crop",
      sendToServer: { dataType: "CropType_control" },
      requiredKey: "crop_type_display",// without this key,
      // reverseSearch:{},
      displayData: { crop_type_display: "crop_type_display", uid: "crop_type_guid" },
    }
  ],

  product: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    // value:lastYearEnd(),
    placeHolder: "Product",
    // label: "Sample Modal",
    name: inputs.name ? inputs.name : "product_code",
    description: "none",
    sendToServer: inputs.sendToServer ? inputs.sendToServer : { dataType: "product" },
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "pdsearch",
      display: 'filter',
      populate: 'code'
    },
    requiredKey: "descn",// without this key,
    displayData: inputs.displayData ? inputs.displayData : {
      descn: "product_code_display", guid: "product_code_guid",
      // producttype: "product_type_guid", productgroup: "product_group" 
    },
    // clearData: inputs.clearData ? inputs.clearData : []
  },

  ],
  customerNumber: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    // value:lastYearEnd(),
    placeHolder: "Customer Number",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "cnsearch",
      display: 'filter',
      populate: 'cin'
    },
    // label: "Sample Modal",
    name: inputs.name ? inputs.name : "customer_number",
    description: "none",
    sendToServer: { sendData: ['parentbranch'], dataType: "customernumber" },
    requiredKey: "description",
    displayData: inputs.displayData ? inputs.displayData : {
      description: "customer_number_display", customer_number_guid: 'customer_number_guid'
      // , pan: "pan", birthday: "dob", address1: "address", home_phone: "home_no", work_phone: "office_no", occupation: "occupation", gender: "gender", pin: "pin", statename: "state", aadhar: "aadhar_id", address2: "add2", cintotbal: "cintotbal", customer_type: "customer_type" 
    },
  },
  ],
  AccountDetails: (inputs = {}) => {
    inputs = { ...inputs, c: "Account", placeHolder: "Account Code", width: 'col-sm-3', name: "account_code", isRequired: false, fastpath: "ms201", isReadOnly: "edit", liveValidation: ["amount"] }
    inputs.displayData = {
      descn: "account_number_display", account_number_guid: 'account_number_guid', account_code: "account_number", branch_code_guid: "branch_code_guid", product_code_guid: "product_code_guid", customer_number: "customer_number"
    }
    return [commonOC(inputs)];
  },

  AccountNumber: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    forceRender: inputs.forceRender ? inputs.forceRender : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    // value:lastYearEnd(),
    placeHolder: "Account No",
    // label: "Sample Modal",
    name: inputs.name ? inputs.name : "account_number",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "atsearch",
      display: 'filter',
      populate: 'accountno'
    },
    onLeave: inputs.onLeave ? inputs.onLeave : [],
    beforeLeave: inputs.beforeLeave ? inputs.beforeLeave : [],
    sendToServer: { sendData: ['branch_code_guid', 'product_code_guid'], dataType: "accountno" },
    requiredKey: "descn",
    displayData: inputs.displayData ? inputs.displayData : {
      descn: "account_number_display", account_number_guid: 'account_number_guid', account_code: "account_number", branch_code_guid: "branch_code_guid", product_code_guid: "product_code_guid", customer_number: "customer_number"
    },
    // clearData: inputs.clearData ? inputs.clearData : [],
    description: "none"
  }],
  daysinterest: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "modalinput",
      // isRequired: true,
      textType: 'number',
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      parents: inputs.parents ? inputs.parents : [],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-2",
        children: "col-sm-12"
      },
      isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
      // value:lastYearEnd(),
      placeHolder: "Days",
      validations: [
        {
          rule: "^(?:36[0-4]|3[0-4]\d|[12]\d{2}|[1-9]\d?)",
          message: "must be less than or equal to 364 days"
        }
      ],

      // label: "Sample Modal",
      name: "deposit_period_days",
      sendToServer: { sendData: [{ varname: 'as_on_date', value: 'Deposits.as_on_date' }, { varname: 'deposit_amount', value: 'Deposits.deposit_amount' }, { varname: 'deposit_period_month', value: 'Deposits.deposit_period_month' }, { varname: "interest_freq", value: "Deposits.interest_freq" }, 'product_code_guid'], dataType: "calculateinterestrate" },
      requiredKey: "ReadIntRate",
      displayData: { ReadIntRate: "ints_rate", GetAddDate: 'maturity_date', GenerateInterestSchedule: "intsche" },
      description: "none"
    }],
  numberofinstallment: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    // isRequired: true,
    textType: 'number',
    tab: inputs.tab ? inputs.tab : "",
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-4",
      children: "col-sm-12"
    },
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    // value:lastYearEnd(),
    placeHolder: "No Of Installment",

    // label: "Sample Modal",
    name: "deposit_period_month",
    sendToServer: { sendData: [{ varname: 'as_on_date', value: 'account_opening_date' }, { varname: 'deposit_amount', value: 'Deposits.deposit_amount' }, 'product_code_guid'], dataType: "calculaterecurringinterestrate" },
    requiredKey: "ReadIntRate",
    displayData: { ReadIntRate: "ints_rate", CalculateMaturityAmount: 'maturity_amount', GenerateInterestSchedule: "intsche" },
    description: "none"
  }],
  GL: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    isRequired: inputs.isRequired ? inputs.isRequired : "",

    parents: inputs.parents ? inputs.parents : [],
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    // value:lastYearEnd(),
    placeHolder: "GL",
    // label: "Sample Modal",
    name: inputs.name ? inputs.name : "gl_code",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "glsearch",
      display: 'filter',
      populate: 'refcode'
    },

    sendToServer: { dataType: "gl" },
    requiredKey: "description",
    displayData: inputs.displayData ? inputs.displayData : { description: "gl_code_display", guid: "gl_guid", refacct: "gl" },
    description: "none"
  }
  ],
  ProductGroup: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "select",
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      parents: inputs.parents ? inputs.parents : [],
      defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
      options: inputs.options ? inputs.options : [{
        label: "Deposit",
        value: "Deposit"
      },
      {
        label: "Loan",
        value: "Loan"
      },
      {
        label: "Bank",
        value: "Bank"
      },
      {
        label: "Other",
        value: "Other"
      },
      {
        label: "Internal",
        value: "Internal"
      }],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
        children: "col-sm-12"
      },
      placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
      name: inputs.name ? inputs.name : "product_group",
      // label:inputs.label? inputs.label:"",
      description: inputs.description ? inputs.description : ""
    },
  ],
  TransactionType: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "select",
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      parents: inputs.parents ? inputs.parents : [],
      defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
      options: inputs.options ? inputs.options : [{
        label: "All",
        value: "all"
      },
      {
        label: "Cash",
        value: "cash"
      },
      {
        label: "Transfer",
        value: "transfer"
      },
      {
        label: "Clearing",
        value: "clearing"
      }],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
        children: "col-sm-12"
      },
      placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
      name: inputs.name ? inputs.name : "transaction_type",
      // label:inputs.label? inputs.label:"",
      description: inputs.description ? inputs.description : ""
    },
  ],
  ReceiptPayments: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "select",
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      parents: inputs.parents ? inputs.parents : [],
      defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
      options: inputs.options ? inputs.options : [
        {
          label: "Receipts",
          value: "Receipts"
        },
        {
          label: "Payments",
          value: "Payments"
        },
        {
          label: "Receipts And Payments",
          value: "Receipts And Payments"
        },
        {
          label: "Opening balance Receipts And Payments",
          value: "Opening balance Receipts And Payments"
        }, {
          label: "Receipts Payments and Closing balance",
          value: "Receipts Payments and Closing balance"
        }, {
          label: "Opening Balance Receipts Payments and Closing balance",
          value: "Opening Balance Receipts Payments and Closing balance"
        },
      ],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
        children: "col-sm-12"
      },
      placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
      name: inputs.name ? inputs.name : "receipt_payments",
      // label:inputs.label? inputs.label:"",
      description: inputs.description ? inputs.description : ""
    },
  ],
  BalanceInterest: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "select",
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      parents: inputs.parents ? inputs.parents : [],
      defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
      options: inputs.options ? inputs.options : [
        {
          label: "Principal",
          value: "Principal"
        },
        {
          label: "Prn-Interest ",
          value: "Prn-Interest"
        },
        {
          label: "Interest",
          value: "Interest"
        },
        {
          label: "Penal",
          value: "Penal"
        }, {
          label: "Postage",
          value: "Postage"
        }, {
          label: "Notice",
          value: "Notice"
        },
        {
          label: "Court",
          value: "Court"
        },
        {
          label: "Insurance",
          value: "Insurance"
        },
        {
          label: "Surcharge",
          value: "Surcharge"
        }, {
          label: "Other",
          value: "Other"
        },
        {
          label: "Principal And PrnInterest",
          value: "Principal And PrnInterest"
        },
        {
          label: "Other Than Principal And PrnInterest",
          value: "Other than Principal And PrnInterest"
        },
        {
          label: "PrnInterest and Interest",
          value: "PrnInterest and Interest"
        },
        {
          label: "All",
          value: "All"
        },
        {
          label: "Principal And Interest Separate",
          value: "Principal And Interest Separate"
        },
      ],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
        children: "col-sm-12"
      },
      placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
      name: inputs.name ? inputs.name : "balance_interest",
      // label:inputs.label? inputs.label:"",
      description: inputs.description ? inputs.description : ""
    },
  ],
  MemberType: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "select",
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      parents: inputs.parents ? inputs.parents : [],
      defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
      options: inputs.options ? inputs.options : [{
        label: "Regular",
        value: "Regular"
      },
      {
        label: "Associated",
        value: "Associated"
      },
      {
        label: "Nominal(B class)",
        value: "Nominal(B class)"
      },
      {
        label: "All Members",
        value: "All Members"
      },
      {
        label: "No Members",
        value: "No Members"
      },
      {
        label: "All",
        value: "All"
      }],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
        children: "col-sm-12"
      },
      placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
      name: inputs.name ? inputs.name : "member_type",
      // label:inputs.label? inputs.label:"",
      description: inputs.description ? inputs.description : ""
    },
  ],
  HavingSign: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "select",
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      parents: inputs.parents ? inputs.parents : [],
      defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
      options: inputs.options ? inputs.options : [
        {
          label: "Having Sign",
          value: "with_sign"
        },
        {
          label: "Without sign",
          value: "without_sign"
        }],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
        children: "col-sm-12"
      },
      placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
      name: inputs.name ? inputs.name : "sign_filter",
      // label:inputs.label? inputs.label:"",
      description: inputs.description ? inputs.description : ""
    },
  ],
  HavingPhoto: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "select",
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      parents: inputs.parents ? inputs.parents : [],
      defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
      options: inputs.options ? inputs.options : [{
        label: "",
        value: ""
      },
      {
        label: "Having Photo",
        value: "with_photo"
      },
      {
        label: "Without Photo",
        value: "without_photo"
      }],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
        children: "col-sm-12"
      },
      placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
      name: inputs.name ? inputs.name : "photo_filter",
      // label:inputs.label? inputs.label:"",
      description: inputs.description ? inputs.description : ""
    },
  ],
  DaysMonths: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "select",
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      parents: inputs.parents ? inputs.parents : [],
      defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
      options: inputs.options ? inputs.options : [
        {
          label: "Days",
          value: "days"
        },
        {
          label: "Months",
          value: "months"
        }],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
        children: "col-sm-12"
      },
      placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
      name: inputs.name ? inputs.name : "days_month",
      // label:inputs.label? inputs.label:"",
      description: inputs.description ? inputs.description : ""
    },
  ],
  BSGroup: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "select",
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      parents: inputs.parents ? inputs.parents : [],
      defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
      options: inputs.options ? inputs.options : [
        {
          label: "Liability",
          value: "liability"
        },
        {
          label: "Asset",
          value: "asset"
        }],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
        children: "col-sm-12"
      },
      placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
      name: inputs.name ? inputs.name : "bsgroup",
      // label:inputs.label? inputs.label:"",
      description: inputs.description ? inputs.description : ""
    },
  ],
  PLGroup: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "select",
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      parents: inputs.parents ? inputs.parents : [],
      defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
      options: inputs.options ? inputs.options : [
        {
          label: "Profit",
          value: "profit"
        },
        {
          label: "Loss",
          value: "loss"
        }],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
        children: "col-sm-12"
      },
      placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
      name: inputs.name ? inputs.name : "plgroup",
      // label:inputs.label? inputs.label:"",
      description: inputs.description ? inputs.description : ""
    },
  ],
  PrintReceiptPayments: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "select",
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      parents: inputs.parents ? inputs.parents : [],
      defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
      options: inputs.options ? inputs.options : [{
        label: "Total",
        value: "total"
      },
      ],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
        children: "col-sm-12"
      },
      placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
      name: inputs.name ? inputs.name : "print_receipt_payments",
      // label:inputs.label? inputs.label:"",`
      description: inputs.description ? inputs.description : ""
    },
  ],
  VoucherType: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "select",
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      parents: inputs.parents ? inputs.parents : [],
      defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
      options: inputs.options ? inputs.options : [
        { value: "0", label: "BATCH" },
        { value: "1", label: "CASHBATCH" },
        { value: "11", label: "CASHRECEIPT" },
        { value: "12", label: "CASHPAYMENT" },
        { value: "2", label: "TRANSFER" },
        { value: "31", label: "CLEARINGCR" },
        { value: "32", label: "CLEARINGDR" },
        { value: "33", label: "CLEARINGCRRET" },
        { value: "34", label: "CLEARINGDRRET" },
        { value: "3", label: "PYGTRF" },
        { value: "4", label: "STANDING" },
        { value: "5", label: "CLOSURE" },
        { value: "6", label: "RTGS" },
        { value: "7", label: "NEFT" },
        { value: "9", label: "IMPS" },
        { value: "8", label: "INTAPPL" },
        { value: "10", label: "ABB" },
        { value: "13", label: "ABBDRSDCC" },
        { value: "15", label: "HOADV" },
        { value: "99", label: "YEAREND" },
        { value: "98", label: "PERIODICALS" },
        { value: "16", label: "ATMCASHRECEIPT" },
        { value: "17", label: "ATMCASHPAYMENT" },
        { value: "18", label: "WALLET" },
        { value: "19", label: "AADHAR" },
        { value: "20", label: "ECS" },
        { value: "21", label: "RTGSO" },
        { value: "14", label: "IMPSO" },
        { value: "22", label: "ACHCR" },
        { value: "23", label: "ACHDR" },
        { value: "24", label: "PAYROLL" },
        { value: "25", label: "AUTORENEW" },
        { value: "26", label: "DEPRECIATION" }],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
        children: "col-sm-12"
      },
      placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
      name: inputs.name ? inputs.name : "vou_type",
      // label:inputs.label? inputs.label:"",
      description: inputs.description ? inputs.description : ""
    },
  ],
  IntFrequency: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "select",
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      parents: inputs.parents ? inputs.parents : [],
      defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
      options: inputs.options ? inputs.options : [
        {
          label: "Monthly",
          value: "Monthly"
        },
        {
          label: "Quartrly",
          value: "Quartrly"
        },
        {
          label: "Half Yearly",
          value: "HalfYearly"
        },
        {
          label: "Yearly",
          value: "Yearly"
        },
        {
          label: "Maturity Time",
          value: "MaturityTime"
        }
      ],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
        children: "col-sm-12"
      },
      placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
      name: inputs.name ? inputs.name : "interest_freq",
      // label:inputs.label? inputs.label:"",
      description: inputs.description ? inputs.description : ""
    },
  ],
  RecPayType: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "select",
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      parents: inputs.parents ? inputs.parents : [],
      defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
      options: inputs.options ? inputs.options : [
        {
          label: "Receipts",
          value: "Receipts"
        },
        {
          label: "Payments",
          value: "Payments"
        },
        {
          label: "Receipts And Payments",
          value: "Receipts And Payments"
        },
        {
          label: "Opening balance Receipts And Payments",
          value: "Opening balance Receipts And Payments"
        }, {
          label: "Receipts Payments and Closing balance",
          value: "Receipts Payments and Closing balance"
        }, {
          label: "Opening Balance Receipts Payments and Closing balance",
          value: "Opening Balance Receipts Payments and Closing balance"
        },
      ],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
        children: "col-sm-12"
      },
      placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
      name: inputs.name ? inputs.name : "Receipt_Payment",
      // label:inputs.label? inputs.label:"",
      description: inputs.description ? inputs.description : ""
    },
  ],
  FreezeTypes: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "select",
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      parents: inputs.parents ? inputs.parents : [],
      defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
      options: inputs.options ? inputs.options : [
        {
          label: "Credit Freeze",
          value: "creditfreeze"
        },
        {
          label: "Debit Freeze",
          value: "debitfreeze"
        }, {
          label: "Full Freeze",
          value: "fullfreeze"
        }, {
          label: "Partial Freeze",
          value: "partialfreeze"
        }, {
          label: "Unfreeze",
          value: "unfreeze"
        }
      ],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
        children: "col-sm-12"
      },
      placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
      name: inputs.name ? inputs.name : "block_level",
      // label:inputs.label? inputs.label:"",
      description: inputs.description ? inputs.description : ""
    },
  ],
  BloodGroup: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "select",
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      parents: inputs.parents ? inputs.parents : [],
      defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
      options: inputs.options ? inputs.options : [
        {
          label: "A +ve",
          value: "apos"
        },
        {
          label: "A -Ve",
          value: "aneg"
        },
        {
          label: "B +Ve",
          value: "bpos"
        },
        {
          label: "B -Ve",
          value: "bneg"
        },
        {
          label: "AB +ve",
          value: "abpos"
        },
        {
          label: "AB -Ve",
          value: "abneg"
        },
        {
          label: "O +ve",
          value: "opos"
        },
        {
          label: "O -Ve",
          value: "oneg"
        },
      ],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
        children: "col-sm-12"
      },
      placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
      name: inputs.name ? inputs.name : "product_group",
      // label:inputs.label? inputs.label:"",
      description: inputs.description ? inputs.description : ""
    },
  ],
  TDSFlag: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "select",
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      parents: inputs.parents ? inputs.parents : [],
      defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
      options: inputs.options ? inputs.options : [
        // {
        //   label: "TDS Applicable",
        //   value: "Applicable"
        // },
        {
          label: "Member TDS Applicable",
          value: "MemberApplicable"
        },
        {
          label: "Form 15AA TDS Applicable",
          value: "Form15AAApplicable"
        },
        {
          label: "Member TDS Not Applicable",
          value: "MemberNotApplicable"
        },
        {
          label: "Form 15H TDS Not Applicable",
          value: "Form15HNotApplicable"
        },
        {
          label: "Form 15AA TDS Not Applicable",
          value: "Form15AANotApplicable"
        }, {
          label: "Form 15G TDS Not Applicable",
          value: "Form15GNotApplicable"
        }, {
          label: "Form 60 TDS Not Applicable",
          value: "Form60NotApplicable"
        }, {
          label: "Form 61 TDS Not Applicable",
          value: "Form61NotApplicable"
        }
      ],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
        children: "col-sm-12"
      },
      placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
      name: inputs.name ? inputs.name : "",
      // label:inputs.label? inputs.label:"",
      description: inputs.description ? inputs.description : ""

    },
  ],
  CustomerType: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "select",
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      parents: inputs.parents ? inputs.parents : [],
      defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
      options: inputs.options ? inputs.options : [
        {
          label: "individual",
          value: "individual"
        },
        {
          label: "internal",
          value: "internal"
        },
        {
          label: "Other",
          value: "other"
        }
      ],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
        children: "col-sm-12"
      },
      placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
      name: inputs.name ? inputs.name : "customer_type",
      // label:inputs.label? inputs.label:"",
      description: inputs.description ? inputs.description : ""
    },
  ],
  CustomerGroup: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Customer Group",
    // label: "Sample Modal",
    name: "customer_group",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "custgroupsearch",
      display: 'filter',
      populate: 'code'
    },
    description: "none",
    sendToServer: { dataType: "customergroup" },
    requiredKey: "description",// without this key, 
    displayData: { description: "customer_group_display", refrid: "customer_group_guid" },

  }
  ],
  Gender: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "select",
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      parents: inputs.parents ? inputs.parents : [],
      defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
      options: inputs.options ? inputs.options : [
        {
          label: "Male",
          value: "male"
        },
        {
          label: "Female",
          value: "female"
        },
        {
          label: "Other",
          value: "other"
        }
      ],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
        children: "col-sm-12"
      },
      placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
      name: inputs.name ? inputs.name : "",
      // label:inputs.label? inputs.label:"",
      description: inputs.description ? inputs.description : ""
    },
  ],
  RiskCategory: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "select",
      tab: inputs.tab ? inputs.tab : "",
      isRequired: inputs.isRequired ? inputs.isRequired : "",
      parents: inputs.parents ? inputs.parents : [],
      defaultValue: inputs.defaultValue ? inputs.defaultValue : "",
      options: inputs.options ? inputs.options : [
        {
          label: "Low Risk",
          value: "lowrisk"
        },
        {
          label: "Medium Risk",
          value: "mediumrisk"
        },
        {
          label: "High Risk",
          value: "highrisk"
        }
      ],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-4 col-md-3 col-lg-2",
        children: "col-sm-12"
      },
      placeHolder: inputs.placeHolder ? inputs.placeHolder : "",
      name: inputs.name ? inputs.name : "",
      // label:inputs.label? inputs.label:"",
      description: inputs.description ? inputs.description : ""
    },
  ],
  chequeNumber: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Cheque_Number",
    // label: "Sample Modal",
    name: "cheque_number",
    onLeave: inputs.onLeave ? inputs.onLeave : [],
    sendToServer: { sendData: ['account_number_guid', 'cheque_date'], dataType: "cheque_status" },
    displayData: { Cheque_Auth_By_Guid: "cheque_number_guid", blocked: "cheque_status", recno: "cheque_recno" },
    description: "none"
  }
  ],
  State: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "State",
    // label: "Sample Modal",
    name: inputs.name ? inputs.name : "state",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "statesearch",
      display: 'filter',
      populate: 'code'
    },

    sendToServer: { dataType: "state" },
    requiredKey: "description",
    displayData: inputs.displayData ? inputs.displayData : { description: "state_display", refrid: "state_guid" },
    description: "none"
  }
  ], District: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    // isRequired: true,
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "District",
    // label: "Sample Modal",
    name: inputs.name ? inputs.name : "district",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "districtsearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "district" },
    requiredKey: "description",
    displayData: inputs.displayData ? inputs.displayData : { description: "district_display", refrid: "district_guid" },
    description: "none"
  }],
  Group: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    // isRequired: true,
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Group",
    // label: "Sample Modal",
    name: "group",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "groupsearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "group" },
    requiredKey: "descn",
    displayData: { descn: "group_display", guid: "group_guid", },
    description: "none"
  }],
  Region: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    // isRequired: true,
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Region",
    // label: "Sample Modal",
    name: "Region",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "regionsearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "region" },
    requiredKey: "description",
    displayData: { description: "region_display", refrid: "region_guid", },
    description: "none"
  }],
  Taluka: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Taluka",
    // label: "Sample Modal",
    name: inputs.name ? inputs.name : "taluka",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "talukasearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "taluka" },
    requiredKey: "description",
    displayData: inputs.displayData ? inputs.displayData : { description: "taluka_display", refrid: "taluka_guid" },
    description: "none"
  }],
  Village: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Village",
    // label: "Sample Modal",
    name: inputs.name ? inputs.name : "village",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "villagesearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "village" },
    requiredKey: "description",
    displayData: inputs.displayData ? inputs.displayData : { description: "village_display", refrid: "village_guid" },
    description: "none"
  }],
  MaritalStatus: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Marital Status",
    // label: "Sample Modal",
    name: "marital_status",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "maritalstatusearch",
      display: 'filter',
      populate: 'code'
    },

    sendToServer: { dataType: "maritalstatus" },
    requiredKey: "description",
    displayData: { description: "marital_status_display", refrid: "marital_status_guid" },
    description: "none"
  }], Occupation: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Occupation",
    // label: "Sample Modal",
    name: "occupation",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "occupationsearch",
      display: 'filter',
      populate: 'code'
    },

    sendToServer: { dataType: "occupation" },
    requiredKey: "description",
    displayData: { description: "occupation_display", refrid: "occupation_guid" },
    description: "none"
  }],
  Religion: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Religion",
    // label: "Sample Modal",
    name: "religion",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "religionsearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "religion" },
    requiredKey: "description",
    displayData: { description: "religion_display", refrid: "religion_guid" },
    description: "none"
  }],
  Cast: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Cast",
    // label: "Sample Modal",
    name: "cast",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "castsearch",
      display: 'filter',
      populate: 'code'
    },

    sendToServer: { dataType: "cast" },
    requiredKey: "description",
    displayData: { description: "cast_display", refrid: "cast_guid" },
    description: "none"
  },
  ], POA: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Proof of Address",
    // label: "Sample Modal",
    name: inputs.name ? inputs.name : "proof_of_address",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "proofaddsearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "proofAddress" },
    requiredKey: "description",
    displayData: inputs.displayData ? inputs.displayData : { description: "proof_of_address_display", refrid: "proof_of_address_guid" },
    description: "none"
  }
  ],
  POI: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Proof of Identity",
    // label: "Sample Modal",
    name: "proof_of_identity",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "proofidentitysearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "proofIdentity" },
    requiredKey: "description",
    displayData: { description: "proof_of_identity_display", refrid: "proof_of_identity_guid" },
    description: "none"
  }],
  IncomeGroup: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Income Group",
    // label: "Sample Modal",
    name: "income_group",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "incomegroupsearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "incomegroup" },
    requiredKey: "description",
    displayData: { description: "income_group_display", refrid: "income_group_guid" },
    description: "none"
  },
  ],
  Division: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",

    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Division",
    // label: "Sample Modal",
    name: "division",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "divisionsearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "division" },
    requiredKey: "description",
    displayData: { description: "division_display", refrid: "division_guid" },
    description: "none"
  }],
  SubDivision: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Sub Division",
    // label: "Sample Modal",
    name: "sub_division",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "subdivisionsearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "subdivision" },
    requiredKey: "description",
    displayData: { description: "sub_division_display", refrid: "sub_division_guid" },
    description: "none"
  }], Area: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Area",
    // label: "Sample Modal",
    name: inputs.name ? inputs.name : "area",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "areasearch",
      display: 'filter',
      populate: 'code'
    },

    sendToServer: { dataType: "area" },
    requiredKey: "text",
    displayData: inputs.displayData ? inputs.displayData : { text: "area_display", MarginPercent: "area_pin_display", refid: "area_guid" },
    description: "none"
  }
  ], Reason: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Reason",
    // label: "Sample Modal",
    name: "reason",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "reasonsearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "reason" },
    requiredKey: "description",
    displayData: { description: "reason_display", refrid: "reason_guid" },
    // description: "none"
  }],
  RelationCode: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Relation Code",
    // label: "Sample Modal",
    name: "relation_code",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "relcodesearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "relationcode" },
    requiredKey: "description",
    displayData: { description: "relation_code_display", refrid: "relation_code_guid" },
    description: "none"
  }],
  JointType: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Joint Type",
    // label: "Sample Modal",
    name: "jointtype_code",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "jointtypesearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "jointtypecode" },
    requiredKey: "description",
    displayData: { description: "jointtype_code_display", refrid: "jointtype_code_guid" },
    description: "none"
  }],

  Security: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Security",
    // label: "Sample Modal",
    name: "security",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "securitysearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "security" },
    requiredKey: "description",
    displayData: { text: "security_display", refid: "security_guid" },
    description: "none"
  }],
  VehicleType: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "VehicleType",
    // label: "Sample Modal",
    name: "vehicletype",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "vehicletypesearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "vehicletype" },
    requiredKey: "description",
    displayData: { description: "vehicletype_display", guid: "vehicletype_guid" },
    description: "none"
  }],
  SanctionBy: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "SanctionBy",
    // label: "Sample Modal",
    name: "sanctionby",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "sanctionbysearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "sanctionby" },
    requiredKey: "description",
    displayData: { description: "sanctionby_display", refrid: "sanctionby_guid" },
    description: "none"
  }],
  ReferencedBy: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "ReferencedBy",
    // label: "Sample Modal",
    name: "referencedby",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "referencedbysearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "referencedby" },
    requiredKey: "description",
    displayData: { description: "referencedby_display", refrid: "referencedby_guid" },
    description: "none"
  }], Purpose: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Purpose",
    // label: "Sample Modal",
    name: "purpose",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "purposesearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "purpose" },
    requiredKey: "text",
    displayData: { text: "purpose_display", refid: "purpose_guid" },
    description: "none"
  }],
  PrioritySector: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "PrioritySector",
    // label: "Sample Modal",
    name: "priority_sector",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "prioritysectorsearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "prioritysector" },
    requiredKey: "text",
    displayData: { text: "priority_sector_display", refid: "priority_sector_guid" },
    description: "none"
  }], PrioritySegment: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "PrioritySegment",
    // label: "Sample Modal",
    name: "priority_segment",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "prioritysegmentsearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "prioritysegment" },
    requiredKey: "text",
    displayData: { text: "priority_segment_display", refid: "priority_segment_guid" },
    description: "none"
  }],
  Category: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Category",
    // label: "Sample Modal",
    name: "category",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "categorysearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "category" },
    requiredKey: "description",
    displayData: { description: "category_display", refrid: "category_guid" },
    description: "none"
  }],
  IndustryType: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "IndustryType",
    // label: "Sample Modal",
    name: "industrytype",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "industrytypesearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "industrytype" },
    requiredKey: "description",
    displayData: { description: "industrytype_display", refrid: "industrytype_guid" },
    description: "none"
  }], Health: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Health",
    // label: "Sample Modal",
    name: "health",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "healthsearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "health" },
    requiredKey: "description",
    displayData: { description: "health_display", refrid: "health_guid" },
    description: "none"
  }],
  AccountType: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Account Type",
    // label: "Sample Modal",
    name: "account_type",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "accounttypesearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "accttype" },
    requiredKey: "description",
    displayData: { description: "account_type_display", refrid: "account_type_guid", code: "account_type" },
    description: "none"
  }],
  ProductType: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: "force",
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Product Type",
    // label: "Sample Modal",
    name: "product_type",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "producttypesearch",
      display: 'filter',
      populate: 'refrid',
      extrafield: { text: "product_type_display", guid: "product_type_guid" }
    },
    sendToServer: inputs.sendToServer ? inputs.sendToServer : { dataType: "producttype" },
    requiredKey: "description",
    displayData: { text: "product_type_display", guid: "product_type_guid", code: "product_type" },
    description: "none"
  }],
  LoanAction: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: true,
    isReadOnly: "force",
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,

    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Loan Action",
    // label: "Sample Modal",
    name: "loan_action",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "loanactionsearch",
      display: 'filter',
      populate: 'refid',
      extrafield: { text: "loan_action_display", refid: "loan_action_guid" }
    },
    sendToServer: { dataType: "loanaction" },
    requiredKey: "text",
    displayData: { text: "loan_action_display", refid: "loan_action_guid", code: "loan_action" },
    description: "none"
  }],
  NpaStatus: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    // isReadOnly: true,
    isReadOnly: "force",
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "NPA Status",
    // label: "Sample Modal",
    name: "npa_status",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "npastatussearch",
      display: 'filter',
      populate: 'refrid',
      extrafield: { text: "npa_status_display", refrid: "npa_status_guid" }
    },
    sendToServer: { dataType: "npastatus" },
    requiredKey: "description",
    displayData: { description: "npa_status_display", refrid: "npa_status_guid" },
    description: "none"
  }],

  ModeOfOperation: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Mode Of Operation",
    // label: "Sample Modal",
    name: "mode_of_operation",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "modeofopsearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "modeofop" },
    requiredKey: "description",
    displayData: { description: "mode_of_operation_display", refrid: "mode_of_operation_guid", code: "mode_of_operation" },
    description: "none"
  }],
  CIBILAccountType: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "CIBIL Account Type",
    // label: "Sample Modal",
    name: "cibil_account_type",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "cibilaccounttypesearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "cibilaccounttype" },
    requiredKey: "description",
    displayData: { description: "cibil_account_type_display", refrid: "cibil_account_type_guid" },
    description: "none"
  }], Society: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Society",
    // label: "Sample Modal",
    name: "society",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "societysearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "society" },
    requiredKey: "description",
    displayData: { description: "society_display", refrid: "society_guid" },
    description: "none"
  }],
  GoldCode: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "GoldCode",
    // label: "Sample Modal",
    name: "gold_code",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "goldcodesearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "goldcode" },
    requiredKey: "description",
    displayData: { description: "gold_code_display", refrid: "gold_code_guid" },
    description: "none"
  }],
  MemberNo: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "MemberNo",
    // label: "Sample Modal",
    name: "memberno",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "membernosearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "memberno" },
    requiredKey: "description",
    displayData: { description: "memberno_display", refrid: "memberno_guid" },
    description: "none"
  }],
  RefDirector: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Ref Director",
    // label: "Sample Modal",refdirector
    name: "ref_director",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "refdirectorsearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "refdirector" },
    requiredKey: "description",
    displayData: { description: "ref_director_display", refrid: "ref_director_guid" },
    description: "none"
  }],
  RelativeDirector: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Relative Director",
    // label: "Sample Modal",refdirector
    name: "relative_director",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "refdirectorsearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "refdirector" },
    requiredKey: "description",
    displayData: { description: "relative_director_display", refrid: "relative_director_guid" },
    description: "none"
  }],
  Title: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Title",
    // label: "Sample Modal",
    name: "title",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "titlesearch",
      display: 'filter',
      populate: 'code'
    },
    sendToServer: { dataType: "title" },
    requiredKey: "description",
    displayData: { description: "title_display", refrid: "title_guid" },
    description: "none"
  }],
  ledgergroup: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Ledger Group",
    // label: "Sample Modal",
    name: "ledger_group",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "ledgergroupsearch",
      display: 'filter',
      populate: 'code'
    },

    sendToServer: { dataType: "ledgergroup" },
    requiredKey: "display",
    displayData: { display: "ledger_group_display", refid: "ledger_group_guid" },
    description: "none"
  }
  ],
  AuthorisedSign: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Authorised Sign",
    // label: "Sample Modal",
    name: inputs.name ? inputs.name : "authorised_sign",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "authorisedsignsearch",
      display: 'filter',
      populate: "code"
    },

    sendToServer: { dataType: "authorisedsign", sendData: ['branch_code_guid'] },
    requiredKey: "Description",
    displayData: inputs.displayData ? inputs.displayData : { Description: "authorised_sign_display", Refrid: "authorised_sign_guid" },
    description: "none"
  }
  ],
  IfscCode: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Ifsc Code",
    // label: "Sample Modal",
    name: "ifsc_code",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "ifsccodesearch",
      display: 'filter',
      populate: 'code'
    },

    sendToServer: { dataType: "ifsccode" },
    requiredKey: "descn",
    displayData: { descn: "ifsccode_display", guid: "ifsccode_guid", bankname: "ifsc_bankname", address: "ifsccode_address" },
    description: "none"
  }
  ],
  BankCode: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Bank Code",
    // label: "Sample Modal",
    name: "bank_code",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "bankcodesearch",
      display: 'filter',
      populate: 'code'
    },

    sendToServer: { dataType: "bankcode" },
    requiredKey: "description",
    displayData: { description: "bank_code_display", refrid: "bank_code_guid" },
    description: "none"
  }
  ],
  SponsorBankCode: (inputs = {}) => [{
    tag: inputs.tag,
    icon: inputs.icon ? inputs.icon : "",
    inputType: "modalinput",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : '',
    isRequired: inputs.isRequired ? inputs.isRequired : "",
    parents: inputs.parents ? inputs.parents : [],
    // isRequired: true,
    tab: inputs.tab ? inputs.tab : "",
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-2",
      children: "col-sm-12"
    },
    // value:lastYearEnd(),
    placeHolder: "Sponsor Bank Code",
    // label: "Sample Modal",
    name: "sponsor_bank_code",
    formmodal: {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "fastpathContainer",
      pagename: "sponsorbankcodesearch",
      display: 'filter',
      populate: 'code'
    },

    sendToServer: { dataType: "sponsorbankcode" },
    requiredKey: "description",
    displayData: { description: "sponsor_bank_code_display", refrid: "sponsorbank_code_guid" },
    description: "none"
  }
  ],

  Multibutton: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "multibutton",
      tab: inputs.tab ? inputs.tab : "create",
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-12",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: inputs.label ? inputs.label : "Button",
      onclick: inputs.onclick ? inputs.onclick : {},
      formmodal: inputs.formmodal ? inputs.formmodal : {},
      options: inputs.options ? inputs.options : [],
      name: inputs.name ? inputs.name : "",
      parents: inputs.parents ? inputs.parents : [],
      description: "",
      Bcolor: inputs.Bcolor ? inputs.Bcolor : "primary",
      size: inputs.size ? inputs.size : "sm",
      sendToServer: inputs.sendToServer ? inputs.sendToServer : {},
      // displayData: inputs.displayData ? inputs.displayData :{},
      convertedTo: inputs.convertedTo ? inputs.convertedTo : "",
      requiredField: inputs.requiredField ? inputs.requiredField : [],
      style: inputs.style ? inputs.style : {}
    },
  ],


  button: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "button",
      tab: inputs.tab ? inputs.tab : "create",
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-12",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: inputs.label ? inputs.label : "Button",
      onclick: inputs.onclick ? inputs.onclick : {},
      formmodal: inputs.formmodal ? inputs.formmodal : {},
      name: "",
      parents: inputs.parents ? inputs.parents : [],
      description: "",
      Bcolor: inputs.Bcolor ? inputs.Bcolor : "primary",
      size: inputs.size ? inputs.size : "sm",
      sendToServer: inputs.sendToServer ? inputs.sendToServer : {},
      // displayData: inputs.displayData ? inputs.displayData :{},
      convertedTo: inputs.convertedTo ? inputs.convertedTo : "",
      requiredField: inputs.requiredField ? inputs.requiredField : [],
      style: inputs.style ? inputs.style : {},
      isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : false,
    },
  ],
  link: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "link",
      tab: inputs.tab ? inputs.tab : "create",
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-12",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: inputs.label ? inputs.label : "Button",
      onclick: inputs.onclick ? inputs.onclick : {},
      formmodal: inputs.formmodal ? inputs.formmodal : {},
      name: "",
      parents: inputs.parents ? inputs.parents : [],
      description: "",
      Bcolor: inputs.Bcolor ? inputs.Bcolor : "primary",
      size: inputs.size ? inputs.size : "sm",
      sendToServer: inputs.sendToServer ? inputs.sendToServer : {},
      // displayData: inputs.displayData ? inputs.displayData :{},
      convertedTo: inputs.convertedTo ? inputs.convertedTo : "",
      requiredField: inputs.requiredField ? inputs.requiredField : [],
      style: inputs.style ? inputs.style : {}
    },
  ],

  webCamera: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "camera",
      tab: inputs.tab ? inputs.tab : "general",
      // dataType:"aadhaar",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      // value:lastYearEnd(),
      placeHolder: "",
      label: "Photo",
      name: "webcam_photo",
      description: "none",
      camtype: inputs.camtype ? inputs.camtype : null,
      options: inputs.options ? inputs.options : {},
      imageStyle: inputs.imageStyle ? inputs.imageStyle : {
        height: 800,
        width: 600
      },
    },
  ],
  qrCodeReader: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "qrcode",
      tab: "Qrcode",
      dataType: inputs.dataType ? inputs.dataType : "aadhaar",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      onScan: inputs.onScan ? inputs.onScan : null,
      onScanComplete: inputs.onScanComplete ? inputs.onScanComplete : null,
      placeHolder: "",
      label: "Photo",
      name: inputs.name ? inputs.name : "qrcode_data",
      description: "none",
      previewStyle: inputs.previewStyle ? inputs.previewStyle : {
        height: 600,
        width: 600
      },
    },
  ],
  iframe: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "iframe",
      height: inputs.height ? inputs.height : 300,
      url: inputs.url ? inputs.url : "",
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-12",
        children: "col-sm-12"
      }
    },
  ],
  dashboardsGenerator: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      sequence: inputs.sequence ? inputs.sequence : 1,
      inputType: "dashboardsGenerator",
      height: inputs.height ? inputs.height : 300,
      url: inputs.url ? inputs.url : "",
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-12",
        children: "col-sm-12"
      }
    },
  ],
  kpiDisplay: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "kpi",
      values: inputs.values ? inputs.values : false,
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-12",
        children: "col-sm-12"
      }
    },
  ],
  kpiList: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      user: inputs.user ? inputs.user : false,
      ddType: inputs.ddType ? inputs.ddType : false,
      dformat: inputs.dformat ? inputs.dformat : false,
      inputType: "kpilist",
      showvalues: inputs.showvalues ? inputs.showvalues : false,
      values: inputs.values ? inputs.values : false,
      clickable: inputs.clickable ? inputs.clickable : false,
      emptymsg: inputs.emptymsg ? inputs.emptymsg : false,
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-12",
        children: "col-sm-12"
      }
    },
  ],
  listWidget: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      user: inputs.user ? inputs.user : false,
      ddType: inputs.ddType ? inputs.ddType : false,
      dformat: inputs.dformat ? inputs.dformat : false,
      inputType: "listwidget",
      showvalues: inputs.showvalues ? inputs.showvalues : false,
      values: inputs.values ? inputs.values : false,
      clickable: inputs.clickable ? inputs.clickable : false,
      emptymsg: inputs.emptymsg ? inputs.emptymsg : false,
      reportName: inputs.reportName ? inputs.reportName : false,
      format: inputs.format ? inputs.format : { value: false, label: false },
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-12",
        children: "col-sm-12"
      },
      query_group: inputs.query_group ? inputs.query_group : false
    },
  ],
  kpiTable: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "kpitable",
      values: inputs.values ? inputs.values : [],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-12",
        children: "col-sm-12"
      }
    },
  ],
  FollowupList: (inputs = {}) => [
    {
      tag: inputs.tag,
      icon: inputs.icon ? inputs.icon : "",
      inputType: "followuplist",
      values: inputs.values ? inputs.values : [],
      widths: {
        parent: inputs.width ? inputs.width : "col-sm-12",
        children: "col-sm-12"
      }
    },
  ],
  FileUpload: (inputs = {}) => [{
    inputType: "fileupload",
    isReadOnly: inputs.isReadOnly ? inputs.isReadOnly : false,
    params: inputs.params,
    widths: {
      parent: inputs.width ? inputs.width : "col-sm-6",
      children: "col-sm-12"
    },
    label: inputs.label ? inputs.label : "Fileupload",
    name: inputs.name,
    readFile: inputs.readFile ? inputs.readFile : false,
    placeholder: {
      type: "text",
      value: "Upload Sign."
    },
    fileTypes: inputs.fileTypes ? inputs.fileTypes : [],
    Bcolor: "success",
    files: inputs.files ? inputs.files : [],
    multiple: inputs.multi ? inputs.multi : false,
    tab: inputs.tab ? inputs.tab : "filter"
  }]
}


export { controls, currencyToNumber, grouped, where_pending, recovery_percentage, checkCondition };